import { DocumentType } from '../../../enums/document-type';
import { batchPackingSlip } from '../document-type-epic-helpers/batch-packing-slip';
import * as Api from '../print.api';
import { jobRunner } from './job-runner';

/**
 * @typedef {import('./print-job-factory').PrintJob} PrintJob
 */

/**
 * @param {object} args
 * @param {string[]} args.fulfillmentPlanSetIds
 * @param {boolean} args.excludeAlreadyPrinted
 * @param {object} args.printer
 * @param {number} args.documentCount
 * @returns {import('rxjs').Observable<PrintJob>}
 */
export const createBatchPackingSlipsAsync = ({ fulfillmentPlanSetIds, excludeAlreadyPrinted, printer, documentCount }) => {
  const notification = batchPackingSlip.getAsyncPrintStartedNotificationProps(documentCount);
  const errorNotification = batchPackingSlip.getAsyncPrintFailedNotificationProps(documentCount);

  return jobRunner({
    apiRequest: () => Api.generateBatchPackingSlipAsync(fulfillmentPlanSetIds, excludeAlreadyPrinted),
    documentCount,
    documentTypeIdentifier: DocumentType.BatchPackingSlip.identifier,
    initialNotification: notification,
    errorNotification,
    ids: fulfillmentPlanSetIds,
    printer,
  });
};
